import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.277 5.8h3.733m-5.6 2.8h5.6m-5.6 2.8h4.667m5.324 1.867-2.922 3.266-2.333.467.467-2.333 2.924-3.267a1.315 1.315 0 0 1 1.86 0l.007.005a1.316 1.316 0 0 1-.003 1.862Zm-8.124 1.866H4.544a.933.933 0 0 1-.934-.933V3.933A.933.933 0 0 1 4.543 3h9.334a.933.933 0 0 1 .933.933v4.2l-6.533 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);